import { render, staticRenderFns } from "./SnoozeTableModal.vue?vue&type=template&id=ef0d391e"
import script from "./SnoozeTableModal.vue?vue&type=script&lang=js"
export * from "./SnoozeTableModal.vue?vue&type=script&lang=js"
import style0 from "./SnoozeTableModal.vue?vue&type=style&index=0&id=ef0d391e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports